@if (label) {
    <label class="form-label text-white">{{ label }}</label>
}

<ion-select 
    interface="popover" 
    class="rounded px-3 mb-1" 
    value="{{ value }}" 
    placeholder="{{ placeholder }}" 
    [interfaceOptions]="{ style: styleString, side: 'bottom', alignment: 'start' }"
    (ionChange)="change($event.target);"
>
    @for (opt of options; track opt) {
        <ion-select-option value="{{ opt.value }}">
            {{ opt.label }}
        </ion-select-option>
    }
</ion-select>

@if (errorMsg) {
    <label class="is-invalid">{{ errorMsg }}</label>
}
